import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { last } from 'lodash';
import { map } from 'rxjs/operators';
import { TransactionFlowType } from '../enums';
import {
  removeAllProductsFromTransactionAction,
  removeProductFromTransactionAction,
  removeTransactionAction,
  loadTransactionReceiptAction,
  clearTransactionReceiptAction,
} from './transaction.actions';
import { ITransactionFeature } from './transaction.feature.state';
import {
  getFailures,
  getIsLoading,
  getProducts,
  getTransacitonFlowType,
  getTransactionId,
  getTransactionReceipt,
  getTransactionState,
  getWordOfTheDay,
} from './transaction.selectors';

@Injectable()
export class TransactionFacade {
  public transactionState$ = this.store.select(getTransactionState);
  public isLoading$ = this.store.select(getIsLoading);
  public failures$ = this.store.select(getFailures);
  public products$ = this.store.select(getProducts);
  public transactionFlowType$ = this.store.select(getTransacitonFlowType);
  public wordOfTheDay$ = this.store.select(getWordOfTheDay);
  public transactionId$ = this.store.select(getTransactionId);
  public currentProducts$ = this.products$.pipe(map((products) => products.filter((product) => !product.lineIsCorrected)));
  public isTransactionOpened$ = this.store.select(getProducts).pipe(map((products) => !!products && products.length > 0));
  public transactionReceipt$ = this.store.select(getTransactionReceipt);

  public lastAddedProduct$ = this.currentProducts$.pipe(
    map((products) => {
      return products.length ? last(products) : null;
    })
  );
  public noOfItems$ = this.currentProducts$.pipe(
    map((products) => {
      return products.length;
    })
  );
  public totalPrice$ = this.currentProducts$.pipe(
    map((products) => {
      const totalSum = products.reduce((sum, product) => sum + product.price.value, 0);
      return totalSum.toFixed(2);
    })
  );
  public totalTax$ = this.currentProducts$.pipe(
    map((products) => {
      const totalTax = products.reduce((sum, product) => sum + product.taxAmount, 0);
      return totalTax.toFixed(2);
    })
  );

  constructor(private store: Store<ITransactionFeature>) {}

  public removeProductFromTransaction(productLineNo: number): void {
    this.store.dispatch(removeProductFromTransactionAction({ productLineNo }));
  }

  public removeTransaction(): void {
    this.store.dispatch(removeTransactionAction());
  }

  public removeAllProductsFromTransaction(transactionFlowType: TransactionFlowType): void {
    this.store.dispatch(
      removeAllProductsFromTransactionAction({
        transactionFlowType,
      })
    );
  }

  public loadTransactionReceipt(transactionId: number): void {
    this.store.dispatch(loadTransactionReceiptAction({ transactionId }));
  }

  public clearTransactionReceiptAction(): void {
    this.store.dispatch(clearTransactionReceiptAction());
  }
}
